<template>
  <vs-table v-if="show" ref="table" :params="params"></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";

  export default {
    name: "accountsGroup",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        accountsGroupModel: [],

        params: {
          entity: "accountsGroup",
          list: [],
          headers: {
            id: {
              title: "کد",
              type: "text"
            },
            title: {
              title: "نام گروه",
              type: "text"
            }
          }
        },
        options: {
          hasActions: true,
          hasActionsInHeader: true
        }

      };
    },
    mounted() {
      new BaseService('AccountGroups', '/GetPaging/' + 'title=').getList().then(rs => {
        this.accountsGroupModel = rs.data;
        console.log(rs.data);
      });
    },

  };
</script>

<style scoped>

</style>
